const options = [
  {label:"HTML",value: "HTML" },
  {label:"CSS", value: "CSS" },
  {label:"Python", value: "Python" },
  {label:"Javascript", value: "Javascript" },
  {label:"NodeJs", value: "NodeJs" },
  {label:"AngularJs", value: "AngularJs" },
  {label:"ReactJs", value: "ReactJs" },
  {label:"MongoDB", value: "MongoDB" },
  {label:"MySql", value: "MySql" },
  {label:"Bootstrap", value: "Bootstrap" },
  {label:"TailwindCSS", value: "TailwindCSS" },
  {label:"Figma", value: "Figma" },
  {label:"Adobe XD", value: "Adobe XD" },
  {label:"Data Analytics", value: "Data Analytics" },
  {label:"Flutter", value: "Flutter" },
  {label:"Dart", value: "Dart" },
  {label:"Java", value: "Java" },
  {label:"C", value: "C++" },
  {label:"Golang", value: "Golang" },
  {label:"Machine Learning", value: "Machine Learning" },
  {label:"Computer Vision", value: "Computer Vision" },
  {label:"NLP", value: "NLP" },
  {label:"ASR", value: "ASR" },
  {label:"Data Science", value: "Data Science" },
  {label:"Data Engineering", value: "Data Engineering" },
  {label:"VueJS", value: "VueJS" },
  {label:"Solidity", value: "Solidity" },
  {label:"Rust", value: "Rust" },
  {label:"kotlin", value: "kotlin" },
  {label:"Flask", value: "Flask" },
  {label:"Django", value: "Django" },
  {label:"UI/UX", value: "UI/UX" },
  {label:"PostgreSQL", value: "PostgreSQL" },
  {label:"C#", value: "C#" },
  {label:".NET", value: ".NET" },
  {label:"Unity", value: "Unity" },
  {label:"Cloud Computing", value: "Cloud Computing" },
  {label:"AWS", value: "AWS" },
  {label:"Firebase", value: "Firebase" },
  {label:"Power BI", value: "Power BI" },
  {label:"Tableau", value: "Tableau" },
  {label:"Excel", value: "Excel" },
  {label:"ExpressJs", value: "ExpressJs" },
  {label:"FastAPI", value: "FastAPI" },
  {label:"REST api", value: "REST api" },
  {label:"Docker", value: "Docker" },
  {label:"DevOps", value: "DevOps" },
  {label:"MLOps", value: "MLOps" },
  {label:"IOT", value: "IOT" },
  {label:"AR/VR", value: "AR/VR" },
  {label:"Mixed Reality", value: "Mixed Reality" },
  {label:"Linux", value: "Linux" },
  {label:"PHP", value: "PHP" },
  {label:"Laravel", value: "Laravel" },
  {label:"C", value: "C" },
  {label:"NextJS", value: "NextJS" },
  {label:"Artificial intelligence", value: "Artificial intelligence" },
];

export default options;
